module.exports = __webpack_public_path__ + "img/theme10.414623e5.png";